import 'babel-polyfill'
import './assets/custom-element/theme/index.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './plugins/gj-components.js'
import './plugins/vxe-table'
// import "./utils/burying-point";
import * as filters from './filters' // global filters
import * as directives from './directives' // global directives
import drag  from './directives/drag'// global directives
import echarts from 'echarts'
import VCharts from 'v-charts'
import 'v-charts/lib/style.css'
import '@/assets/iconfont/iconfont.css'
import '@/assets/iconfont/iconfont.js'
import _ from 'lodash';
import '@/assets/styles/index.scss'
import gjCreate from "@/components/create"; // global css
import VueLazyComponent from '@xunlei/vue-lazy-component'
import {Message} from "element-ui";
import request from "@/utils/request";
import {mapGetters} from "vuex";
import NP from 'number-precision'
import TtlStorage from '@/utils/storage'
import Cache from "@/utils/cache";
import CacheData from '@/utils/cacheData'
import sensorsdata from './sensorsdata.es6.min';
import VueRouter from 'vue-router'
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import { useVirtualEnv, sentryRelease } from "@/utils/sentryConfig"

// @ts-ignore
window.sensorsdata = sensorsdata;
// var sensorsdata = window['sensorsDataAnalytic201505'];
sensorsdata.init({
  server_url: 'https://shence.apist.gerpgo.com/sa?project=default',
  heatmap: {
    scroll_notice_map: 'not_collect',
    collect_tags: {
      div : true,
      li: true,
      img: true,
      label: true,
      span: true
    }
  },
  is_track_single_page: () => false,
  use_client_time: true,
  show_log: false,
  send_type: 'beacon'
});
// sensorsdata.quick('autoTrack');
sensorsdata.registerPage({
  current_url: function () {
    return location.href;
  },
  referrer: function() {
    return document.referrer;
  },
  companyName: function () {
    return window.sensorsdataTenant;
  },
  organizationName: function () {
    // @ts-ignore
    const {organizationName} = window.gjUserInfo || {};
    return organizationName;
  },
  roleName: function () {
    // @ts-ignore
    const {roleName} = window.gjUserInfo || {};
    return roleName;
  },
  app: 'M'
});


const storage = new TtlStorage({
  timestamp: 0,
  namespace: 'GJ'
})

// 业务模块查询参数缓存
const cache = new Cache('local')

// 防止重复点击报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)}
Vue.use(VueRouter)

Vue.use(VCharts)
Vue.use(VueLazyComponent)
// promise complete
Promise.prototype.complete = function(callback) {
  let p = this.constructor;
  return this.then(
    value => p.resolve(callback()).then(()=>value),
    reason => {
      if(typeof reason === 'object'){
        if(reason.message !== "cancelToken"){
          p.resolve(callback()).then(()=>{throw reason})
        }
      }else{
         p.resolve(callback()).then(()=>{throw reason})
      }

    }
  )
};

Array.prototype.flatMap = function(fn) {
  if (fn) {
    return _.flatMap(this, fn);
  }
  return _.flatMap(this);
};


Vue.prototype.$cache = cache

// register gjCreate
Vue.prototype.$gjCreate = gjCreate;

// register gjRequest
Vue.prototype.$gjRequest = request;

Vue.prototype.$gjMessage = Message;

Vue.prototype.$NP = NP;

// register echart
Vue.prototype.$echarts = echarts;
import '../node_modules/echarts/map/js/world.js'

// register lodash
Vue.prototype._ = _;

// register clientWidth
Vue.prototype.clientWidth = document.body.clientWidth;

Vue.prototype.$storage = storage

// 全局挂载query查询参数缓存类
Vue.prototype.$cacheData = CacheData
// 挂载全局缓存tab实例
Vue.prototype.$cacheTab = new CacheData({module: 'TAB'})
// 挂载全局缓存query实例
Vue.prototype.$cacheQuery = new CacheData({module: 'QUERY'})
// 挂载全局缓存pagination实例
Vue.prototype.$cachePages = new CacheData({module: 'PAGES'})

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
});

// register global utility filters
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key])
});


Vue.config.productionTip = true;

Vue.mixin({
  computed: {
    ...mapGetters(['userResources', 'useLoadResources'])
  },
  methods: {
    $permission(resources = [], condition = 'all') {
      if (typeof resources === 'string') { // 单个资源
        return this.$existResource(resources);
      } else { // 资源数组
        if (condition.toLocaleLowerCase() === 'all') {
          return resources.every((resource) => this.$existResource(resource));
        } else if (condition.toLocaleLowerCase() === 'some') {
          return resources.some((resource) => this.$existResource(resource));
        } else {
          return false;
        }
      }
    },
    $permissionNum(resources = []) {
      return resources.filter((resource) => this.$existResource(resource)).length;
    },
    $existResource(resource) {
      if (this.userResources) {
        return this.userResources.includes(resource);
      }
      return false;
    }
  }
});

// 生产环境
if (process.env.NODE_ENV === 'production') {
  const env = useVirtualEnv();
  const release = sentryRelease('1.0.0')
  if(['test', 'prod', 'production'].includes(env)) {
    Sentry.init({
      Vue,
      dsn: "https://a1eca7aec0b146a0bbf0b6fc51309dda@sentry.app.gerpgo.com/9",
      trackComponents: ["gjTable"],
      integrations: [
        new BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
          // tracingOrigins: ["mdemo.gerpgo.cn", "erp.gerpgo.com", "test.gerpgo.com", /^\//],
        }),
      ],
      release,
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 0.3,
      environment: env
    });
  }
}


window.$Vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
